export default {"src":"/_next/static/media/integrations-desk.dc4b0863.svg","height":353,"width":417,"blurWidth":0,"blurHeight":0};